module.exports = __webpack_public_path__ + "static/media/kid23.fdd3ceac.png";